import styled from "styled-components";
import { colors } from "../styles/Variables";

export const StatusAproved = styled.div`
    margin-right: 25px;
`
export const Saldo = styled.div`
    border-radius: 30%;
    background-color: ${props => props.backgroundColor};
    color: ${colors.white};
    padding: 15px;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const Wallet = styled.img`
    height: 85%;
    @media (max-width: 1024px) {
        width: 42px;
        height: auto;
    }
    @media(max-width: 768px){
        width: 32px;
        height: auto;
    }
`